import type { ParentFolderContext } from './types';
import { googleFetch } from '../client';

export interface GoogleDriveChildFolder {
  id: string;
  name: string;
  parents?: string[];
  mimeType?: string;
}

export type GoogleDriveChildFoldersListParams = ParentFolderContext;

export interface GoogleDriveChildFoldersListResponse {
  folders: GoogleDriveChildFolder[];
}

export async function googleDriveChildFoldersList(
  params: GoogleDriveChildFoldersListParams
): Promise<GoogleDriveChildFoldersListResponse> {
  return googleFetch<GoogleDriveChildFoldersListResponse>(
    '/rpc/google_drive_child_folders_list',
    {
      body: params,
    }
  );
}
